// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.config.productionTip = false;
import { dispatchEventStroage } from "@/utils/validate";
Vue.use(dispatchEventStroage)

import Video from 'video.js'
import 'video.js/dist/video-js.css'

import 'babel-polyfill'

import App from './App'
import router from './router'

Vue.prototype.$video = Video

Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})












// WEBPACK FOOTER //
// ./src/main.js